const CachePolicy = Object.freeze({
  NETWORK_ONLY: 'network_only',
  CACHE_EXISTS: 'cache_exists',
});

export default CachePolicy;
